import { Component, Inject, OnInit } from '@angular/core';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CaseNoStructure, FieldCode, FieldCodes } from '@app/shared/models/case-number-settings';
import { Office } from '@app/shared/models/office';
import { Case } from '@app/shared/models/case';
import { TranslationEntry } from '@app/shared/models/translatable';


export interface CaseNumberStructureDialogData {
    case: Case;
    caseNoStructure: CaseNoStructure;
    officeStructures: CaseNoStructure[];
    offices: Office[];
    selectedOffice: Office;
}

export interface CaseNumberStructureDialogResult {
    selectedOffice: Office;
    freeText1?: string;
    freeText2?: string;
}

@Component({
    templateUrl: './case-number-dialog.component.html',
    styleUrls: ['./case-number-dialog.component.scss']
})
export class CaseNumberDialogComponent extends BaseComponent
                                       implements OnInit {

    public freeText1: TranslationEntry;
    public freeText2: TranslationEntry;

    public freeText1Value: string;
    public freeText2Value: string;

    public selectedOffice: Office;

    constructor(public dialogRef: MatDialogRef<CaseNumberDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: CaseNumberStructureDialogData) {
        super();
        this._idPrefix = 'case_number_dialog.';
    }

    protected setAvailableFields(): void {
        this.freeText1 = this.data.caseNoStructure.fields.find(field => field.identifier_code === FieldCode.CASE_FREE_1) ? FieldCodes.CASE_FREE_1 : null;
        this.freeText1 = this.data.caseNoStructure.fields.find(field => field.identifier_code === FieldCode.CASE_FREE_2) ? FieldCodes.CASE_FREE_2 : null;
        this.freeText1Value = '';
        this.freeText2Value = '';
    }

    public ngOnInit() {
        super.ngOnInit();
        this.selectedOffice = this.data.selectedOffice;
        this.setAvailableFields();
    }

    public onOfficeChange(): void {
        this.data.caseNoStructure = this.data.officeStructures.find((x) => x.reference_id === this.data.selectedOffice.id);
        this.setAvailableFields();
    }

    public accept(): void {
        const result: CaseNumberStructureDialogResult = {
            selectedOffice: this.selectedOffice
        };

        if (this.freeText1) {
            result.freeText1 = this.freeText1Value;
        }

        if (this.freeText2) {
            result.freeText2 = this.freeText2Value;
        }

        this.dialogRef.close(result);
    }

    public close(): void {
        this.dialogRef.close(false);
    }
    
}
